// src/data/tiers.js

// Retail Platform Default Fallbacks (3. Retail platform)
export const agent = {
  initials: "AK",
  name: "Ahmed Khan",
  commission: 6.0,
  tierLabel: "SILVER (TIER 2)",
  rating: 4.7,
  clients: 75,
  connect: 140,
};

export const tiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "25", connect: "50+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon profile setup & verification doc submission (KYC/CNIC)",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Region Unlocked (Primary Hub / Lahore HQ)", "Standard Agent Portal & Basic Client Directory"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "50", connect: "100+", rating: "≥ 4.0",
    subs: ["(You: 75)", "(You: 140)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["1 Region Operations (Lahore HQ Active Operational)", "Client Referral Network Access & Standard Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "100", connect: "200+", rating: "≥ 4.2",
    subs: ["(25 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Region: Karachi Hub Activated (2 Total Regions)", "Priority Agent Desk Concierge & Directory Badge"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "175", connect: "350+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Regions (Islamabad Hub Unlocked)", "Wholesale Multi-Domain Access & Express Verification"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "275", connect: "500+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 Total Regional Territories Nationwide", "Dedicated Territory Manager & Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "400", connect: "700+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Total Operating Regions Unlocked", "Co-branded Marketing & Corporate Enterprise Leads"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "550", connect: "900+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Total Operating Regions Across Pakistan", "Regional Sub-Agent Onboarding & Revenue Share"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "750", connect: "1,200+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 Total Regions (National Presence)", "Executive Advisory Council Seat & Custom Fee Schedule"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "1,000", connect: "1,500+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 Regional Expansion Nodes", "Global Expansion Pilot & Annual Keynote Pass"],
    status: "locked",
  },
];

export const pinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "1,500+ Clients",
  connect: "2,500+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 Regional Hubs Nationwide Unlocked", "Lifetime Global Ambassador Status & Franchise Rights"],
};

export const stepper = [
  { lvl: 1, rate: "5.0%", label: "Lvl 1 (Bronze)" },
  { lvl: 2, rate: "6.0%", label: "Lvl 2 (Silver)" },
  { lvl: 3, rate: "7.0%", label: "Lvl 3 (Gold)" },
  { lvl: 4, rate: "8.0%", label: "Lvl 4" },
  { lvl: 5, rate: "9.0%", label: "Lvl 5" },
  { lvl: 6, rate: "10.0%", label: "Lvl 6" },
  { lvl: 7, rate: "11.0%", label: "Lvl 7" },
  { lvl: 8, rate: "12.5%", label: "Lvl 8" },
  { lvl: 9, rate: "13.5%", label: "Lvl 9" },
  { lvl: 10, rate: "15.0% MAX", label: "Lvl 10 ★" },
];

// 4. Wholesaler Platform Default Fallbacks
export const wholesalerTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "15", connect: "30+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon wholesale credential setup & tax/trade license submission",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Wholesale Regional Hub Unlocked (Lahore Trade HQ)", "B2B Bulk Procurement Directory & Inquiry Desk"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "30", connect: "60+", rating: "≥ 4.0",
    subs: ["(You: 45)", "(You: 80)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Active Wholesale Operations & Volume Discount Gateway", "Direct Supplier-Retailer Referral Network Access"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "60", connect: "120+", rating: "≥ 4.2",
    subs: ["(15 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Wholesale Region: Karachi Hub Activated (2 Total Regions)", "Verified Wholesaler Directory Badge & Priority Tender Alerts"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "100", connect: "200+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Regions (Islamabad Enterprise Node)", "Cross-Category B2B Matching & Fast-Track Settlement"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "175", connect: "350+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 Regional Distribution Channels Nationwide", "Dedicated B2B Account Director & Contract Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "250", connect: "500+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Operating Wholesale Supply Nodes Unlocked", "Enterprise Distributor Co-marketing & Inbound Tender Placement"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "350", connect: "700+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Industrial Trade Corridors Across Pakistan", "National Bulk Buyer Syndication & Bulk Payout Escalation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "500", connect: "900+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 Wholesale Regions (National Trade Footprint)", "Executive Advisory Board Seat & Preferred Procurement Terms"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "700", connect: "1,200+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 National Supply Expansion Hubs", "Global Import-Export Pilot Access & VIP Industry Summit"],
    status: "locked",
  },
];

export const wholesalerPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "1,000+ Clients",
  connect: "1,800+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 National Commercial Trade Hubs Unlocked", "Lifetime SelectEzi Wholesaler Ambassador & Franchise Rights"],
};

// 5. Manufacturer Platform Default Fallbacks
export const manufacturerTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "10", connect: "20+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon factory credential setup & industrial trade license submission",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Manufacturing Regional Corridor Unlocked (Lahore Industrial Zone)", "Industrial Supplier & Commercial Buyer Directory Access"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "20", connect: "40+", rating: "≥ 4.0",
    subs: ["(You: 25)", "(You: 50)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Active Factory & Distributor Network Gateway", "Commercial Order Referral Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "40", connect: "80+", rating: "≥ 4.2",
    subs: ["(15 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Corridor: Karachi Industrial Hub (2 Total Corridors)", "Verified Industrial Partner Badge & Priority Tender Board"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "75", connect: "150+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Manufacturing Hubs (Islamabad / Rawalpindi)", "Direct Supply-Chain Pipeline & Fast Settlement"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "125", connect: "250+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 National Industrial Zones Across Pakistan", "Dedicated Enterprise Account Lead & Contract Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "200", connect: "400+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Operating Production Hubs Unlocked", "Co-branded Industrial Marketing & Corporate Leads"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "275", connect: "550+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Heavy Industrial Clusters Across Pakistan", "OEM / Private Label Syndication & Bulk Payout Escalation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "375", connect: "750+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 National Manufacturing Zones (All Major Provinces)", "Industrial Advisory Council Seat & Custom Volume Tariffs"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "500", connect: "1,000+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 Industrial Corridors & International Export Route", "Cross-Border Trade Delegation & Global Keynote Pass"],
    status: "locked",
  },
];

export const manufacturerPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "750+ Clients",
  connect: "1,500+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 National Industrial Hubs Nationwide", "Lifetime SelectEzi Industrial Ambassador & Franchise Rights"],
};

// 6. Raw Material Platform Default Fallbacks
export const rawmaterialTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "8", connect: "15+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon raw material trade credential submission & facility verification",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Raw Material Sourcing Hub Unlocked (Lahore Trade HQ)", "Primary Material Exchange Directory & Producer Inquiries"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "15", connect: "30+", rating: "≥ 4.0",
    subs: ["(You: 18)", "(You: 35)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Bulk Raw Goods Matching Gateway", "Direct Factory-Source Procurement Network"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "30", connect: "60+", rating: "≥ 4.2",
    subs: ["(12 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Sourcing Depot: Karachi Hub (2 Total Hubs)", "Verified Material Sourcing Badge & Advance Supply Alerts"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "50", connect: "100+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Regional Resource Hubs (Punjab & KPK)", "Direct Supply Chain Matching & Fast Track Clearance"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "80", connect: "150+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 National Material Distribution Depots", "Dedicated Raw Materials Account Manager & Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "125", connect: "250+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Processing & Extraction Sourcing Nodes", "Enterprise Producer Co-marketing & Supply Tenders"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "175", connect: "350+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Regional Material Depots Across Pakistan", "Consortium Supply Payout Escalation & Bulk Allocation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "250", connect: "500+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 National Resource Centers (All-Province Coverage)", "Raw Material Policy Advisory Seat & Guaranteed Pricing Access"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "350", connect: "700+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 National Resource Corridors", "International Material Import-Export Pilot & Summit Pass"],
    status: "locked",
  },
];

export const rawmaterialPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "500+ Clients",
  connect: "1,000+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 Specialized Material Hubs Across Pakistan", "Lifetime SelectEzi Raw Material Ambassador & Franchise Rights"],
};

// 7. Services Platform Default Fallbacks
export const servicesTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "15", connect: "30+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon professional service accreditation & portfolio submission",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Service Operations Hub Unlocked (Lahore Regional HQ)", "Client Service Directory & Basic Scheduling Portal"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "30", connect: "60+", rating: "≥ 4.0",
    subs: ["(You: 40)", "(You: 70)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Service Referral Network Access", "Standard Service Contract Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "60", connect: "120+", rating: "≥ 4.2",
    subs: ["(20 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Territory: Karachi Hub (2 Total Territories)", "Verified Professional Services Directory Badge"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "100", connect: "200+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Regional Service Territories Unlocked", "Corporate Client Retainer Matching & Express Verification"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "175", connect: "350+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 Regional Service Centers Across Pakistan", "Dedicated Service Territory Director & Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "250", connect: "500+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Metropolitan Service Hubs Unlocked", "Enterprise Corporate RFP & Consulting Tender Placements"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "350", connect: "700+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Multi-City Service Networks Across Pakistan", "Regional Sub-Contractor Management & Revenue Share"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "500", connect: "1,000+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 National Service Hubs (All Major Cities)", "Executive Advisory Seat & Custom Service Fee Schedule"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "700", connect: "1,400+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 Regional Enterprise Service Hubs", "Nationwide Fleet / Professional Team Syndication"],
    status: "locked",
  },
];

export const servicesPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "1,000+ Clients",
  connect: "2,000+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 Metropolitan & Industrial Service Hubs Nationwide", "Lifetime SelectEzi Services Ambassador & Franchise Rights"],
};

// 8. Transport Platform Default Fallbacks
export const transportTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "8", connect: "15+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon transport fleet verification & logistics license submission",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Logistics Corridor Unlocked (Lahore Freight HQ)", "Logistics Operator & Freight Shipper Directory"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "15", connect: "30+", rating: "≥ 4.0",
    subs: ["(You: 18)", "(You: 35)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Commercial Fleet & Cargo Referral Access", "Standard Freight Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "30", connect: "60+", rating: "≥ 4.2",
    subs: ["(12 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Logistics Corridor: Karachi Port Terminal (2 Total Hubs)", "Verified Transport Provider Directory Badge & Fleet Priority"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "50", connect: "100+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Freight Corridors (Islamabad Cargo Node)", "Multi-Fleet B2B Matching & Fast Settlement"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "80", connect: "160+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 National Logistics Corridors Across Pakistan", "Dedicated Fleet Operations Manager & Freight Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "125", connect: "250+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Inter-City Transport Corridors Unlocked", "Enterprise Fleet Co-Branded Marketing & Inbound Cargo Placement"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "175", connect: "350+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 National Freight Corridors Across Pakistan", "Cross-Province Dispatch Syndication & Bulk Payout Escalation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "250", connect: "500+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 Logistics Corridors (National Freight Footprint)", "Logistics Advisory Board Seat & Preferred Carrier Terms"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "350", connect: "700+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 Major Highway Expansion Hubs", "International Cross-Border Pilot Access & VIP Transport Summit"],
    status: "locked",
  },
];

export const transportPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "500+ Clients",
  connect: "1,000+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 National Highway Logistics Hubs Unlocked", "Lifetime SelectEzi Transport Ambassador & Fleet Franchise Rights"],
};

// 9. Food Platform Default Fallbacks
export const foodTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "20", connect: "40+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon food safety accreditation & restaurant/shop license submission",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Culinary Region Unlocked (Lahore Food Hub)", "Restaurant & Hospitality Vendor Directory"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "40", connect: "80+", rating: "≥ 4.0",
    subs: ["(You: 55)", "(You: 95)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Food Supply & Catering Referral Access", "Standard Vendor Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "80", connect: "160+", rating: "≥ 4.2",
    subs: ["(25 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Culinary Territory: Karachi Food Hub (2 Total Regions)", "Verified Food Brand Directory Badge & Priority Catering Placement"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "125", connect: "250+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Culinary Territories (Islamabad Metro Node)", "Institutional Kitchen & Bulk Food Supply Matching"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "200", connect: "400+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 Regional Food Distribution Networks Across Pakistan", "Dedicated Hospitality Director & Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "300", connect: "600+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Provincial Culinary Operations Unlocked", "National Restaurant Chain Co-Marketing & Inbound Lead Placement"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "425", connect: "850+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Industrial & Consumer Food Corridors Across Pakistan", "Franchise Supply Syndication & Bulk Payout Escalation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "600", connect: "1,200+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 National Food Hubs (All Major Metropolitan Areas)", "Executive Culinary Advisory Seat & Custom Supply Terms"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "800", connect: "1,600+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 Metropolitan Food Hubs", "Global Food Export Pilot & Annual Culinary Expo Pass"],
    status: "locked",
  },
];

export const foodPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "1,200+ Clients",
  connect: "2,400+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 National Food & Hospitality Hubs Nationwide Unlocked", "Lifetime SelectEzi Food Ambassador & Master Franchise Rights"],
};

// 10. Companies Platform Default Fallbacks
export const companiesTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "12", connect: "25+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon corporate documentation submission & registration verification",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Corporate Operations Node Unlocked (Lahore Central HQ)", "Corporate Registry & B2B Partner Directory"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "25", connect: "50+", rating: "≥ 4.0",
    subs: ["(You: 30)", "(You: 60)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Cross-Industry Commercial Network Access", "Corporate Contract Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "50", connect: "100+", rating: "≥ 4.2",
    subs: ["(20 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Corporate Node: Karachi Commercial Hub (2 Total Hubs)", "Verified Enterprise Badge & Priority Business Tender Desk"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "80", connect: "160+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Corporate Enterprise Nodes (Islamabad Capital Node)", "Multi-Sector Commercial Syndicate Matching"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "125", connect: "250+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 Regional Corporate Centers Across Pakistan", "Dedicated Corporate Account Lead & Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "200", connect: "400+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Metropolitan Corporate Hubs Unlocked", "National Corporate Lead Syndication & Co-Branded Media"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "275", connect: "550+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 Multi-Province Commercial Nodes Across Pakistan", "Inter-Enterprise Revenue Share & Bulk Payout Escalation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "375", connect: "750+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 National Corporate Hubs (All Major Provinces)", "Executive Business Advisory Board Seat & Custom Fee Schedule"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "500", connect: "1,000+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 National Corporate Hubs", "Global Enterprise Trade Expansion Pilot & Keynote Pass"],
    status: "locked",
  },
];

export const companiesPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "750+ Clients",
  connect: "1,500+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 National Corporate Hubs Nationwide Unlocked", "Lifetime SelectEzi Corporate Ambassador & Franchise Rights"],
};

// 11. Property Platform Default Fallbacks
export const propertyTiers = [
  {
    id: 1, name: "Bronze Starter", star: "1st", commission: "5.0% Base Rate", rate: "5.0%",
    clients: "8", connect: "15+", rating: "≥ 3.5",
    subs: [null, null, null],
    verify: "1st Star upon real estate agency credentials & property license submission",
    prereq: "Tier 1 Verified Completion",
    benefits: ["1st Property Regional Hub Unlocked (Lahore Metro Property HQ)", "Real Estate Agent, Investor & Developer Directory"],
    status: "completed",
  },
  {
    id: 2, name: "Silver Agent", star: "2nd", commission: "6.0% (+1.0% Perk Active)", rate: "6.0%",
    clients: "15", connect: "30+", rating: "≥ 4.0",
    subs: ["(You: 18)", "(You: 35)", "(You: 4.7★)"],
    prereq: "Tier 1 Verified Completion",
    benefits: ["Direct Landlord-Tenant Referral Network Access", "Standard Property Commission Payout Gateway"],
    status: "current",
  },
  {
    id: 3, name: "Gold Agent", star: "3rd", commission: "7.0% (+1.0% Rate Hike)", rate: "7.0%",
    clients: "30", connect: "60+", rating: "≥ 4.2",
    subs: ["(12 Left)", "(✓ Met)", "(✓ 4.7)"],
    prereq: "Tier 2 Active Standing",
    benefits: ["+1 Regional Property Hub: Karachi Metro Node (2 Total Hubs)", "Verified Real Estate Firm Directory Badge & Priority Listings"],
    status: "next",
  },
  {
    id: 4, name: "Platinum Specialist", star: "4th", commission: "8.0% Commission", rate: "8.0%",
    clients: "50", connect: "100+", rating: "≥ 4.4",
    prereq: "Tier 3 Gold Attained",
    benefits: ["3 Total Regional Property Nodes (Islamabad Capital Hub)", "Commercial & Residential Syndication Pipeline"],
    status: "locked",
  },
  {
    id: 5, name: "Ruby Partner", star: "5th", commission: "9.0% Commission", rate: "9.0%",
    clients: "80", connect: "160+", rating: "≥ 4.5",
    prereq: "Tier 4 Platinum Attained",
    benefits: ["4 Regional Real Estate Territories Across Pakistan", "Dedicated Property Portfolio Manager & Performance Bonus"],
    status: "locked",
  },
  {
    id: 6, name: "Emerald Director", star: "6th", commission: "10.0% Commission", rate: "10.0%",
    clients: "125", connect: "250+", rating: "≥ 4.6",
    prereq: "Tier 5 Ruby Attained",
    benefits: ["5 Metropolitan Property Corridors Unlocked", "Developer Project Marketing & Corporate Inbound Leads"],
    status: "locked",
  },
  {
    id: 7, name: "Sapphire Executive", star: "7th", commission: "11.0% Commission", rate: "11.0%",
    clients: "175", connect: "350+", rating: "≥ 4.7",
    prereq: "Tier 6 Emerald Attained",
    benefits: ["6 National Property Nodes Across Pakistan", "Megaproject Investor Syndication & Bulk Payout Escalation"],
    status: "locked",
  },
  {
    id: 8, name: "Diamond Ambassador", star: "8th", commission: "12.5% Commission", rate: "12.5%",
    clients: "250", connect: "500+", rating: "≥ 4.8",
    prereq: "Tier 7 Sapphire Attained",
    benefits: ["7 National Property Hubs (All-Province Coverage)", "Real Estate Advisory Board Seat & Preferred Commission Terms"],
    status: "locked",
  },
  {
    id: 9, name: "Crown Master", star: "9th", commission: "13.5% Commission", rate: "13.5%",
    clients: "350", connect: "700+", rating: "≥ 4.9",
    prereq: "Tier 8 Diamond Attained",
    benefits: ["8–9 Regional Development Expansion Hubs", "International Overseas Investor Pilot & VIP Property Summit"],
    status: "locked",
  },
];

export const propertyPinnacle = {
  name: "Star Elite (Pinnacle)",
  star: "10th Star Master Milestone – Ultimate Career Pinnacle",
  clients: "500+ Clients",
  connect: "1,000+ Nodes",
  rating: "5.0 ★ Elite",
  prereq: "Tier 9 Crown Master & Full Compliance Audit",
  commission: "15.0% Maximum Master Ceiling",
  benefits: ["All 10 National Real Estate Hubs Nationwide Unlocked", "Lifetime SelectEzi Property Ambassador & Master Franchise Rights"],
};
